import { Flex, Text } from "@chakra-ui/react"
import { RaceTipsResponse } from "api/generated/graphql"
import FeedbackSlider from "components/StatSlider/FeedbackSlider"

interface TuningComparisonsProps {
  raceTipsData: RaceTipsResponse
  raceLevel: number
  tipsForMetrics: Record<string, string | null>
  userWon: boolean
  userPosition?: number
  competitorPosition?: number
}

type StatField = 'speed' | 'fastTurns' | 'handling' | 'slowTurns' | 'cooling' | 'braking' | 'acceleration' | 'stability';

const TuningComparisons = ({ raceTipsData, raceLevel, tipsForMetrics, userWon, userPosition, competitorPosition }: TuningComparisonsProps) => {
  const { metricsOwn, metricsWinnerLow, metricsWinnerHigh } = raceTipsData

  // Define which stats are available at each level
  const statsPerLevel: Record<number, StatField[]> = {
    1: ["speed", "fastTurns"],
    2: ["speed", "fastTurns"],
    3: ["speed", "fastTurns", "handling"],
    4: ["speed", "fastTurns", "handling", "slowTurns", "cooling"],
    5: ["speed", "fastTurns", "handling", "slowTurns", "cooling", "braking"],
    6: ["speed", "fastTurns", "handling", "slowTurns", "cooling", "braking", "acceleration", "stability"]
  }
  
  // Get available stats based on current race level
  const availableStats = statsPerLevel[raceLevel]
  
  // Map from stat fields to display names
  const statDisplayNames: Record<StatField, string> = {
    speed: "Speed",
    fastTurns: "Fast Turns",
    handling: "Handling",
    slowTurns: "Slow Turns",
    cooling: "Cooling",
    braking: "Braking",
    acceleration: "Acceleration",
    stability: "Stability"
  }

  return (
    <Flex
      w="full"
      flexDir="column"
      gap={4}
    >
      <Text
        fontSize={{ base: '1.125rem', md: '1.5rem' }}
        lineHeight={{ base: '1.5rem', md: '1.75rem' }}
        fontWeight={400}
        background="linear-gradient(180deg, #FFFFFF 0%, #EEEEEE 18%, #A0A0A0 73%, #979797 100%)"
        backgroundClip="text"
        textTransform="uppercase"
        fontFamily="heading"
      >
        Tuning Comparisons
      </Text>
      <Flex direction="column" gap={3}>
        {availableStats.map((stat) => (
          <FeedbackSlider
            key={stat}
            statName={statDisplayNames[stat]}
            statField={stat}
            userValue={metricsOwn?.[stat] ?? 0}
            winnerMinValue={metricsWinnerLow?.[stat] ?? 0}
            winnerMaxValue={metricsWinnerHigh?.[stat] ?? 0}
            tip={tipsForMetrics[stat]}
            userWon={userWon}
            position={userPosition}
            competitorPosition={competitorPosition}
          />
        ))}
        {availableStats.length === 0 && (
          <Text color="whiteAlpha.700">No tuning options available at this race level.</Text>
        )}
      </Flex>
    </Flex>
  )
}

export default TuningComparisons;